import { mergeDeepRight } from 'ramda'

import { types as DoctorTypes } from 'store/Doctor'
import { initialState, types } from './index'

export const getDoctorSortByOptions = () => ({
  type: types.GET_DOCTOR_SORT_BY_OPTIONS,
  payload: [
    {
      label: 'Best match',
      value: 'best-match-asc',
    },
    {
      label: 'Distance',
      value: 'distance-asc',
    },
  ],
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case DoctorTypes.FETCH_SPECIALTIES_SUCCESS: {
      const specialtiyOptions = [
        { name: 'any', value: '', label: 'Any' },
        ...payload.content.map(({ specialty }) => ({
          name: specialty,
          value: specialty,
          label: specialty,
        })),
      ]

      const nextState = {
        ...state,
        filterOptions: mergeDeepRight(state.filterOptions, {
          specialties: specialtiyOptions,
        }),
      }

      const alreadySet = state.filters?.specialty
      return alreadySet
        ? nextState
        : {
            ...state,
            filters: mergeDeepRight(state.filters, {
              specialty: specialtiyOptions[0].value,
            }),
          }
    }

    case types.GET_DOCTOR_SORT_BY_OPTIONS: {
      const nextState = {
        ...state,
        filterOptions: mergeDeepRight(state.filterOptions, {
          sortOptions: payload,
        }),
      }

      const alreadySet = state.filters?.sortBy
      return alreadySet
        ? nextState
        : {
            ...state,
            filters: mergeDeepRight(state.filters, { sortBy: payload[0] }),
          }
    }

    default:
      return state
  }
}
